import { useEffect, useRef, useState } from 'react';

import AppState from '@/js/AppState';
import clsx from 'clsx';
import Loader from 'react-sdk/components/Loader/Loader';
import classes from './Labyrinth.module.css';
import PopupsManager from 'react-sdk/PopupsManager';
import FtueHelper from '@/js/FtueHelper';

const Labyrinth = ({level, onFinished }) => {
  const elementRef = useRef(null)
  const [loaded, setLoaded] = useState(false);
  
  // Labyrinth USE EFFECT INITIAL
  useEffect(() => {

    AppState.reaxe_api.registerModule("labyrinth", (event, params) => {
      if(event === "completed") {       
        let {score} = params // pas sur que ca serve
          if(onFinished) onFinished(score)
      }
      else if(event === "transitionPopup") {
        let done = params.done

        FtueHelper.openFtues(["laby_transition"], "mgs", false, () => done())
      }
    })
    
    //a voir pour les levels
    AppState.reaxe_api.toHaxe("labyrinth", "launch", {level : level}, () => setLoaded(true) )
    AppState.mapVisible = false;
    setTimeout(() => {
      if (AppState.haxeCanvas.parentElement)
        AppState.haxeCanvas.parentElement.removeChild(AppState.haxeCanvas)
      elementRef.current.append(AppState.haxeCanvas)
    }, 50)
    // appelé à la fermeture du composant
    return () => {
      AppState.reaxe_api.toHaxe("labyrinth", "delete", null, 
        () => {
          AppState.mapVisible = true;
          setLoaded(false)
          AppState.reaxe_api.registerModule("labyrinth", null)
        }
      )
    }

  }, []);

  return (
    <div className={clsx(classes.Labyrinth, loaded && classes.loaded)} ref={elementRef} >
    {!loaded &&
    <div className={classes.loader}>
      <Loader />
    </div>
    }
  </div>
  );
};

export default Labyrinth;
